import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';

interface AuthPageProps {
  onAuthSuccess?: () => void;
  onBack?: () => void;
}

const AuthPage: React.FC<AuthPageProps> = ({ onAuthSuccess, onBack }) => {
  const [isSignUp, setIsSignUp] = useState(false);

  const handleAuthSuccess = () => {
    onAuthSuccess?.();
  };

  const switchToSignUp = () => {
    setIsSignUp(true);
  };

  const switchToLogin = () => {
    setIsSignUp(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      {/* 戻るボタン */}
      {onBack && (
        <div className="absolute top-4 left-4 z-50">
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-800 transition-colors p-2 touch-manipulation"
          >
            <span className="text-lg">←</span>
            <span className="text-base">戻る</span>
          </button>
        </div>
      )}
      
      {isSignUp ? (
        <SignUpForm 
          onSignUpSuccess={handleAuthSuccess}
          onSwitchToLogin={switchToLogin}
        />
      ) : (
        <LoginForm 
          onLoginSuccess={handleAuthSuccess}
          onSwitchToSignUp={switchToSignUp}
        />
      )}
    </div>
  );
};

export default AuthPage;
